var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "061E8168-6740-4DE7-8675-10ADF9C35A1B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.01-start-D-thank-you",
    transform: "translate(-105.000000, -187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side-nav",
    transform: "translate(106.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "general-info-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/success-copy",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C18.6275455,24 24,18.6275455 24,12 C24,5.37245455 18.6275455,3.94430453e-31 12,3.94430453e-31 C5.37245455,3.94430453e-31 0,5.37245455 0,12 C0,18.6275455 5.37245455,24 12,24 Z M10.9474364,13.2624545 L8.63350909,10.9474636 L7.09090909,12.4911545 L10.9475455,16.3477909 L12.1055727,15.1908273 L17.5707545,9.72455455 L16.0281545,8.18195455 L10.9474364,13.2624545 Z",
    id: "Page-1",
    fill: "#43C6A4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a06ad0ebce76539ce3111dcd250645fc.svg";
export { ForwardRef as ReactComponent };